export default __webpack_public_path__ + "static/media/4693.a847319e.png";